import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CheckInKioskUiMaterialModule } from './check-in-kiosk-ui-material.module';
import { CheckInComponent } from './check-in/check-in.component';
import { CheckOutComponent } from './check-out/check-out.component';
import { FailureModalComponent } from './failure-modal/failure-modal.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderBackBtnComponent } from './header-back-btn/header-back-btn.component';
import { HeaderComponent } from './header/header.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { WorkflowSelectorComponent } from './workflow-selector/workflow-selector.component';
import { TimeInputAmPmModule } from './time-input-ampm/time-input-ampm.module';
import { TimeInput24hsModule } from './time-input-24hs/time-input-24hs.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CheckInKioskUiMaterialModule,
    TimeInput24hsModule,
    TimeInputAmPmModule,
  ],
  declarations: [
    HeaderComponent,
    HeaderBackBtnComponent,
    FooterComponent,
    WelcomeComponent,
    CheckInComponent,
    CheckOutComponent,
    SuccessModalComponent,
    FailureModalComponent,
    WorkflowSelectorComponent,
  ],
  exports: [
    HeaderComponent,
    HeaderBackBtnComponent,
    FooterComponent,
    WelcomeComponent,
    CheckInComponent,
    CheckOutComponent,
    SuccessModalComponent,
    FailureModalComponent,
    WorkflowSelectorComponent,
  ],
})
export class CheckInKioskUiModule {}
